import { z } from 'zod';
import { partySchema } from '../../common';
import { dateSchema } from '../../validation';

export const orderCancellationReasonSchema = z.enum([
  'no_carrier_available',
  'customer_canceled',
  'customer_change_date',
  'customer_order_mistake',
  'other',
]);
export type OrderCancellationReason = z.infer<typeof orderCancellationReasonSchema>;

export const orderCancellationSchema = z.object({
  /** the reason for the cancellation */
  reason: orderCancellationReasonSchema,
  /** a note to be displayed to the user */
  internalNote: z.coerce.string().trim().optional(),
  /**
   * the issuer of the cancellation. Phase 7 (relations-v2): flipped to
   * a {@link partySchema} snapshot.
   */
  cancelledBy: partySchema,
  /** the date of the cancellation */
  date: dateSchema,
});
export type OrderCancellation = z.infer<typeof orderCancellationSchema>;
